import { render, staticRenderFns } from "./CustomActionList.vue?vue&type=template&id=bd7b190e&scoped=true&"
import script from "./CustomActionList.vue?vue&type=script&lang=js&"
export * from "./CustomActionList.vue?vue&type=script&lang=js&"
import style0 from "./CustomActionList.vue?vue&type=style&index=0&id=bd7b190e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd7b190e",
  null
  
)

export default component.exports